import { render, staticRenderFns } from "./40.vue?vue&type=template&id=f8ef27d0&scoped=true&"
var script = {}
import style0 from "./40.vue?vue&type=style&index=0&id=f8ef27d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ef27d0",
  null
  
)

export default component.exports